import _eol from "eol";
import _fixEnglishTextInRTLLanguage from "../quill/fixEnglishTextInRTLLanguage.js";
import _convertToPlainText from "../quill/convertToPlainText.js";
import _tcLib from "../../lib/timecode.js";
import _cptable from "codepage";
const cptable = _cptable;
const tcLib = _tcLib;
const convertToPlainText = _convertToPlainText;
const fixEnglishTextInRTLLanguage = _fixEnglishTextInRTLLanguage;
const eol = _eol;
export default {
  codePageMapping: {
    "ISO 8859-1 Latin": 28591,
    "ISO 8859-2 Latin 2": 28592,
    "ISO 8859-2 Latin Czech": 28592,
    // alias for existing jobs
    "ISO 8859-5 Cyrillic": 28595,
    "ISO 8859-6 Arabic": 28596,
    "ISO 8859-7 Greek": 28597,
    "ISO 8859-8 Hebrew": 28598,
    "ISO 8859-9 Turkish": 28599,
    "Windows-874 Thai": 874,
    "GBK Simplified Chinese": 936,
    "Big5 Traditional Chinese": 950,
    "Korean": 949,
    "Japanese Shift-JIS": 932
  },
  alignmentMap: {
    "00": "right",
    "01": "left",
    "02": "center"
  },
  getCodeByCmd: function (codes, cmd) {
    let hexValue = Object.keys(codes).find(code => codes[code] === cmd);
    return hexValue ? hexValue.padStart(2, "0") : null;
  },
  convertAsciiToHex: function (asciiText) {
    let hexString = "";
    asciiText.split("").forEach(char => {
      hexString += char.charCodeAt(0).toString(16).padStart(2, "0");
    });
    return hexString;
  },
  convertUnicodeTextToHex: function (text) {
    let utf8Hex = Buffer.from(text, "utf8").toString("hex");
    let bytes = utf8Hex.match(/(..?)/g) || [];
    bytes = bytes.map(function (b) {
      return b === "2e" ? "ff" : b;
    });
    return "1fefbbbf" + bytes.join("") + "2e";
  },
  decodeUtf8Char: function (firstByte, remainingBytes) {
    let b = parseInt(firstByte, 16);
    let len = 1;
    if ((b & 0xF8) === 0xF0) {
      len = 4;
    } else if ((b & 0xF0) === 0xE0) {
      len = 3;
    } else if ((b & 0xE0) === 0xC0) {
      len = 2;
    }
    let chunk = [firstByte];
    for (let i = 1; i < len && remainingBytes.length > 0; i++) {
      chunk.push(remainingBytes.shift());
    }
    try {
      return Buffer.from(chunk.join(""), "hex").toString("utf8");
    } catch (e) {
      return "";
    }
  },
  convertTextToHex: function (text, codePage) {
    let hexString = "";
    let w16Flag = false;
    if (codePage === 936 || codePage === 950 || codePage === 949 || codePage === 932) {
      hexString += "1f5731362e";
      w16Flag = true;
    }
    text.split("").forEach(char => {
      let hexCode;
      if (codePage === 28591 || codePage === 28592) {
        hexCode = this.getCodeByCmd(this.specialLatinChars, char);
      } else if (codePage === 28595) {
        hexCode = this.getCodeByCmd(this.specialCyrillicChars, char);
      } else if (codePage === 28596) {
        hexCode = this.getCodeByCmd(this.specialArabicChars, char);
      } else if (codePage === 28597) {
        hexCode = this.getCodeByCmd(this.specialGreekChars, char);
      } else if (codePage === 28598) {
        hexCode = this.getCodeByCmd(this.specialHebrewChars, char);
      } else if (codePage === 28599) {
        hexCode = this.getCodeByCmd(this.specialTurkishChars, char);
      } else if (codePage === 874) {
        hexCode = this.getCodeByCmd(this.specialThaiChars, char);
      }
      if (!hexCode) {
        hexCode = this.encodeChar(char, codePage);
      }
      if (w16Flag && hexCode.length === 2) {
        hexCode = "00" + hexCode;
      }
      hexString += hexCode;
    });
    return hexString;
  },
  decodeRawTextBytes: function (rawTextBytes, codePage) {
    let rawTextBytesString = rawTextBytes.join("");
    let decodedText = "";
    let italicFlag = false;
    let w16Flag = false;
    let unicodeFlag = false;
    if (rawTextBytesString.includes("1f5731362e")) {
      w16Flag = true;
      rawTextBytesString = rawTextBytesString.replace(/1f5731362e/gmi, "");
    }
    rawTextBytes = rawTextBytesString.match(/(..?)/g);
    if (rawTextBytes && rawTextBytes.length > 0 && rawTextBytes[0] === "ff" && rawTextBytes.slice(0, 4).join("") !== "1fefbbbf") {
      rawTextBytes.shift();
    }
    while (rawTextBytes && rawTextBytes.length > 0) {
      if (rawTextBytes.length >= 4 && rawTextBytes.slice(0, 4).join("") === "1fefbbbf") {
        unicodeFlag = true;
        rawTextBytes.splice(0, 4);
        continue;
      }
      let char = rawTextBytes.shift();
      if (char === "fe" && rawTextBytes.length > 2) {
        decodedText += "\n";
        rawTextBytes.splice(0, 2);
        unicodeFlag = false;
        if (rawTextBytes && rawTextBytes.length > 0 && rawTextBytes[0] === "ff" && rawTextBytes.slice(0, 4).join("") !== "1fefbbbf") {
          rawTextBytes.shift();
        }
      } else if (unicodeFlag) {
        if (char === "2e") {
          unicodeFlag = false;
        } else if (char === "ff") {
          decodedText += ".";
        } else if (char === "3c" || char === "3e") {
          if (italicFlag) {
            decodedText += `</em> `;
            italicFlag = false;
          } else {
            decodedText += " <em>";
            italicFlag = true;
          }
        } else {
          decodedText += this.decodeUtf8Char(char, rawTextBytes);
        }
      } else if (w16Flag && rawTextBytes.length > 0 && this.decodeChar([char + rawTextBytes[0]], codePage)) {
        decodedText += this.decodeChar(char + rawTextBytes.shift(), codePage);
      } else if (char === "3c" || char === "3e") {
        if (italicFlag) {
          decodedText += `</em> `;
          italicFlag = false;
        } else {
          decodedText += " <em>";
          italicFlag = true;
        }
      } else if ((codePage === 28591 || codePage === 28592) && rawTextBytes[0] && this.specialLatinChars[char + rawTextBytes[0]]) {
        // console.log("DUAL CODE", char, rawTextBytes[0], this.specialLatinChars[char + rawTextBytes[0]]);
        decodedText += this.specialLatinChars[char + rawTextBytes.shift()];
      } else if ((codePage === 28591 || codePage === 28592) && this.specialLatinChars[char]) {
        // console.log("SINGLE CODE", char, this.specialLatinChars[char])
        decodedText += this.specialLatinChars[char];
      } else if (codePage === 28595 && rawTextBytes[0] && this.specialCyrillicChars[char + rawTextBytes[0]]) {
        decodedText += this.specialCyrillicChars[char + rawTextBytes.shift()];
      } else if (codePage === 28595 && this.specialCyrillicChars[char]) {
        decodedText += this.specialCyrillicChars[char];
      } else if (codePage === 28596 && rawTextBytes[0] && this.specialArabicChars[char + rawTextBytes[0]]) {
        decodedText += this.specialArabicChars[char + rawTextBytes.shift()];
      } else if (codePage === 28596 && this.specialArabicChars[char]) {
        decodedText += this.specialArabicChars[char];
      } else if (codePage === 28597 && rawTextBytes[0] && this.specialGreekChars[char + rawTextBytes[0]]) {
        // console.log("DUAL CODE", char, rawTextBytes[0], this.specialGreekChars[char + rawTextBytes[0]]);
        decodedText += this.specialGreekChars[char + rawTextBytes.shift()];
      } else if (codePage === 28597 && this.specialGreekChars[char]) {
        decodedText += this.specialGreekChars[char];
      } else if (codePage === 28598 && rawTextBytes[0] && this.specialHebrewChars[char + rawTextBytes[0]]) {
        decodedText += this.specialHebrewChars[char + rawTextBytes.shift()];
      } else if (codePage === 28598 && this.specialHebrewChars[char]) {
        decodedText += this.specialHebrewChars[char];
      } else if (codePage === 28599 && rawTextBytes[0] && this.specialTurkishChars[char + rawTextBytes[0]]) {
        decodedText += this.specialTurkishChars[char + rawTextBytes.shift()];
      } else if (codePage === 28599 && this.specialTurkishChars[char]) {
        decodedText += this.specialTurkishChars[char];
      } else if (codePage === 874 && rawTextBytes[0] && this.specialThaiChars[char + rawTextBytes[0]]) {
        decodedText += this.specialThaiChars[char + rawTextBytes.shift()];
      } else if (codePage === 874 && this.specialThaiChars[char]) {
        decodedText += this.specialThaiChars[char];
      } else {
        // console.log(`Char: ${char} : ${this.decodeChar(char, codePage) || ""}`);
        decodedText += this.decodeChar(char, codePage);
      }
    }
    if (italicFlag) {
      decodedText += "</em>";
    }
    return decodedText;
  },
  // Decode from Hex
  decodeChar: function (charCode, codePage) {
    try {
      let char = cptable[codePage].dec[parseInt(charCode, 16)];
      return char;
    } catch (e) {
      console.log(e.message);
      return "";
    }
  },
  encodeChar: function (char, codePage) {
    try {
      let hexCode = cptable[codePage].enc[char].toString(16);
      return hexCode.padStart(2, "0");
    } catch (err) {
      console.log(err.message);
      console.log(char, codePage, cptable[codePage].enc[char]);
      return "";
    }
  },
  /* Takes array of  hex values and returns a smpteTC: [ "e8", "03", "64", "00" ] -> 10:00:01:00*/
  decodeTc: function (hexTc) {
    let hhmm, ssff, tc, hh, mm, ss, ff;
    hhmm = parseInt(hexTc[1] + hexTc[0], 16).toString().padStart(4, "0");
    ssff = parseInt(hexTc[3] + hexTc[2], 16).toString().padStart(4, "0");
    hh = hhmm.substring(0, 2);
    mm = hhmm.substring(2, 4);
    ss = ssff.substring(0, 2);
    ff = ssff.substring(2, 4);
    tc = hh + ":" + mm + ":" + ss + ":" + ff;
    return tc;
  },
  encodeHeader: function () {
    let header = "";
    header += "01";
    for (let i = 0; i < 22; i++) {
      header += "00";
    }
    header += "60";
    return header;
  },
  encodeFooter: function () {
    let footer = "";
    footer += "ff";
    for (let i = 0; i < 11; i++) {
      footer += "00";
    }
    footer += "11";
    footer += "00";
    footer += this.convertAsciiToHex("dummy end of file");
    return footer;
  },
  encodeTc: function (tcSec, frameRate, dropFrame) {
    let tc = tcLib.secToTcClock(tcSec, frameRate, dropFrame);
    let tcArray = tc.split(/\W/g);
    let mmhh = parseInt(tcArray[0] + tcArray[1]).toString(16).padStart(4, "0");
    let ffss = parseInt(tcArray[2] + tcArray[3]).toString(16).padStart(4, "0");
    let hh = mmhh.substring(2, 4);
    let mm = mmhh.substring(0, 2);
    let ss = ffss.substring(2, 4);
    let ff = ffss.substring(0, 2);
    return hh + mm + ss + ff;
  },
  encodeText: function (event, codePage, unicode) {
    let plainText = convertToPlainText(event.text);
    let textLines = eol.split(plainText);
    let hexCodes = "";
    textLines.forEach((textLine, index) => {
      if (index > 0) {
        hexCodes += "fe";
        hexCodes += this.encodeAlignment(event);
        hexCodes += "03";
      }
      if (unicode) {
        hexCodes += this.convertUnicodeTextToHex(textLine);
      } else {
        hexCodes += this.convertTextToHex(codePage === 28596 || codePage === 58598 ? fixEnglishTextInRTLLanguage(textLine) : textLine, codePage);
      }
    });
    return hexCodes;
  },
  encodeTextLength: function (hexCodes, format, pacHeaderOpt) {
    let length = hexCodes.length / 2 + 4 + pacHeaderOpt.length / 2;
    return length.toString(16).padStart(2, "0");
  },
  encodeYPos: function (event, window) {
    let yPos = event.yPos;

    // If yPos is an integer, convert to flexbox value based on percentage
    if (typeof yPos === 'number') {
      const percentage = yPos / (window?.height || 15);
      const vLine = Math.round(percentage * 11);
      return vLine.toString(16).padStart(2, "0");
    }
    if (yPos === "start") {
      return "01";
    } else if (yPos === "center") {
      return "05";
    } else {
      // yPos === "end"
      let line = 12 - event.text.match(/<\/p>/g).length;
      return line.toString(16).padStart(2, "0");
    }
  },
  encodeAlignment: function (event) {
    if (event.alignment === "left") {
      return "01";
    } else if (event.alignment === "right") {
      return "00";
    } else {
      return "02";
    }
  },
  codePages: ["37", "437", "500", "620", "708", "720", "737", "775", "808", "850", "852", "855", "857", "858", "860", "861", "862", "863", "864", "865", "866", "869", "870", "872", "874", "875", "895", "932", "936", "949", "950", "1010", "1026", "1047", "1132", "1140", "1141", "1142", "1143", "1144", "1145", "1146", "1147", "1148", "1149", "1200", "1201", "1250", "1251", "1252", "1253", "1254", "1255", "1256", "1257", "1258", "1361", "10000", "10001", "10002", "10003", "10004", "10005", "10006", "10007", "10008", "10010", "10017", "10021", "10029", "10079", "10081", "10082", "12000", "12001", "20000", "20001", "20002", "20003", "20004", "20005", "20105", "20106", "20107", "20108", "20127", "20261", "20269", "20273", "20277", "20278", "20280", "20284", "20285", "20290", "20297", "20420", "20423", "20424", "20833", "20838", "20866", "20871", "20880", "20905", "20924", "20932", "20936", "20949", "21025", "21027", "21866", "28591", "28592", "28593", "28594", "28595", "28596", "28597", "28598", "28599", "28600", "28601", "28603", "28604", "28605", "28606", "29001", "38598", "47451", "50220", "50221", "50222", "50225", "50227", "51932", "51936", "51949", "52936", "54936", "57002", "57003", "57004", "57005", "57006", "57007", "57008", "57009", "57010", "57011", "65000", "6500"],
  specialArabicChars: {
    "e081": "أ",
    "e086": "ځ",
    "e09b": "ؤ",
    "e09c": "ئ",
    "e181": "إ",
    "e281": "آ",
    "e781": "اً",
    "80": "ـ",
    "81": "ا",
    "82": "ب",
    "83": "ت",
    "84": "ث",
    "85": "ج",
    "86": "ح",
    "87": "خ",
    "88": "د",
    "89": "ذ",
    "8a": "ر",
    "8b": "ز",
    "8c": "س",
    "8d": "ش",
    "8e": "ص",
    "8f": "ض",
    "90": "ظ",
    "91": "ط",
    "92": "ع",
    "93": "غ",
    "94": "ف",
    "95": "ق",
    "96": "ك",
    "97": "ل",
    "98": "م",
    "99": "ن",
    "9a": "ه",
    "9b": "و",
    "9c": "ى",
    "9d": "ة",
    "9e": "لا",
    "9f": "ي",
    "e09f": "ي",
    "a0": "ء",
    "ad": "ڪ",
    "ae": "ﺭ",
    "b0": "ﺩ",
    "b1": "ﯼ",
    "b3": "۔",
    "3f": "؟",
    "25": "٪",
    "2c": "،",
    "3b": "؛",
    "e7": "\u064B",
    "ea": "\u064C",
    "e8": "\u064D",
    "e5": "\u064E",
    "e4": "\u064F",
    "e6": "\u0650",
    "e3": "\u0651",
    "e9": "\u0652",
    "e2": "\u0653",
    "e0": "\u0654",
    "e1": "\u0655"
  },
  specialLatinChars: {
    "e041": "Ã",
    "e04e": "Ñ",
    "e04f": "Õ",
    "e061": "ã",
    "e06e": "ñ",
    "e06f": "õ",
    "e161": "å",
    "e141": "Å",
    "618a": "ā",
    "418a": "Ā",
    "458a": "Ē",
    "658a": "ē",
    "498a": "Ī",
    "698a": "ī",
    "4f8a": "Ō",
    "6f8a": "ō",
    "558a": "Ū",
    "758a": "ū",
    "E54f": "Ö",
    "E56f": "ö",
    "e541": "Ä",
    "e561": "ä",
    "e555": "Ü",
    "e575": "ü",
    "e241": "Á",
    "e249": "Í",
    "e255": "Ú",
    "e259": "Ý",
    "e261": "á",
    "e265": "é",
    "e269": "í",
    "e245": "É",
    "e275": "ú",
    "e279": "ý",
    "e361": "à",
    "e365": "è",
    "e36f": "ò",
    "e345": "È",
    "e349": "Ì",
    "e34f": "Ò",
    "e369": "ì",
    "e443": "Ĉ",
    "e447": "Ĝ",
    "e448": "Ĥ",
    "e44A": "Ĵ",
    "e453": "Ŝ",
    "eA55": "Ǔ",
    "e463": "ĉ",
    "e467": "ĝ",
    "e468": "ĥ",
    "e46A": "ĵ",
    "e473": "ŝ",
    "eA75": "ǔ",
    "e341": "À",
    "e441": "Â",
    "e461": "â",
    "e643": "Ç",
    "e663": "ç",
    "e445": "Ê",
    "e465": "ê",
    "e545": "Ë",
    "e565": "ë",
    "e449": "Î",
    "e469": "î",
    "e549": "Ï",
    "e569": "ï",
    "e44F": "Ô",
    "e46F": "ô",
    "e355": "Ù",
    "e375": "ù",
    "e455": "Û",
    "e475": "û",
    "e559": "Ÿ",
    "e579": "ÿ",
    "eb41": "Ą",
    "eb61": "ą",
    "e243": "Ć",
    "e263": "ć",
    "eB45": "Ę",
    "eB65": "ę",
    "e24e": "Ń",
    "e26e": "ń",
    "e24f": "Ó",
    "e26f": "ó",
    "e253": "Ś",
    "e273": "ś",
    "e25a": "Ź",
    "e27a": "ź",
    "e85a": "Ż",
    "e87a": "ż",
    "e653": "Ş",
    "e673": "ş",
    "ea67": "ğ",
    "ea47": "Ğ",
    "e849": "İ",
    "e75a": "Ž",
    "e753": "Š",
    "e743": "Č",
    "e77a": "ž",
    "e773": "š",
    "e763": "č",
    "4ce2": "Ľ",
    "74e2": "ť",
    "64e2": "ď",
    "6ce2": "ľ",
    "e020": "˜",
    "e045": "Ẽ",
    "e049": "Ĩ",
    "e055": "Ũ",
    "e056": "Ṽ",
    "e059": "Ỹ",
    "e065": "ẽ",
    "e069": "ĩ",
    "e075": "ũ",
    "e076": "ṽ",
    "e079": "ỹ",
    "e120": "˚",
    "e155": "Ů",
    "e175": "ů",
    "e177": "ẘ",
    "e179": "ẙ",
    "e220": "´",
    "e247": "Ǵ",
    "e24b": "Ḱ",
    "e24c": "Ĺ",
    "e24d": "Ḿ",
    "e250": "Ṕ",
    "e252": "Ŕ",
    "e257": "Ẃ",
    "e25c": "Ǽ",
    "e25d": "Ǿ",
    "e267": "ǵ",
    "e26b": "ḱ",
    "e26c": "ĺ",
    "e26d": "ḿ",
    "e270": "ṕ",
    "e272": "ŕ",
    "e277": "ẃ",
    "e27c": "ǽ",
    "e27d": "ǿ",
    "e320": "`",
    "e34e": "Ǹ",
    "e357": "Ẁ",
    "e359": "Ỳ",
    "e36e": "ǹ",
    "e377": "ẁ",
    "e379": "ỳ",
    "e420": "^",
    "e457": "Ŵ",
    "e459": "Ŷ",
    "e45a": "Ẑ",
    "e477": "ŵ",
    "e479": "ŷ",
    "e47a": "ẑ",
    "e520": "¨",
    "e548": "Ḧ",
    "e557": "Ẅ",
    "e558": "Ẍ",
    "e568": "ḧ",
    "e574": "ẗ",
    "e577": "ẅ",
    "e578": "ẍ",
    "e620": "¸",
    "e644": "Ḑ",
    "e645": "Ȩ",
    "e647": "Ģ",
    "e648": "Ḩ",
    "e64b": "Ķ",
    "e64c": "Ļ",
    "e64e": "Ņ",
    "e652": "Ŗ",
    "e654": "Ţ",
    "e664": "ḑ",
    "e665": "ȩ",
    "e667": "ģ",
    "e668": "ḩ",
    "e66b": "ķ",
    "e66c": "ļ",
    "e66e": "ņ",
    "e672": "ŗ",
    "e674": "ţ",
    "e720": "ˇ",
    "e741": "Ă",
    "e744": "Ď",
    "e745": "Ě",
    "e747": "Ğ",
    "e748": "Ȟ",
    "e749": "Ǐ",
    "e74b": "Ǩ",
    "e74e": "Ň",
    "e74f": "Ǒ",
    "e752": "Ř",
    "e754": "Ť",
    "e755": "Ǔ",
    "e761": "ă",
    "e765": "ě",
    "e768": "ȟ",
    "e769": "ǐ",
    "e76a": "ǰ",
    "e76b": "ǩ",
    "e76e": "ň",
    "e76f": "ǒ",
    "e772": "ř",
    "e775": "ǔ",
    "e820": "˙",
    "e841": "Ȧ",
    "e842": "Ḃ",
    "e843": "Ċ",
    "e844": "Ḋ",
    "e845": "Ė",
    "e846": "Ḟ",
    "e847": "Ġ",
    "e848": "Ḣ",
    "e84d": "Ṁ",
    "e84e": "Ṅ",
    "e84f": "Ȯ",
    "e850": "Ṗ",
    "e852": "Ṙ",
    "e853": "Ṡ",
    "e854": "Ṫ",
    "e857": "Ẇ",
    "e858": "Ẋ",
    "e859": "Ẏ",
    "e861": "ȧ",
    "e862": "ḃ",
    "e863": "ċ",
    "e864": "ḋ",
    "e865": "ė",
    "e866": "ḟ",
    "e867": "ġ",
    "e868": "ḣ",
    "e86d": "ṁ",
    "e86e": "ṅ",
    "e86f": "ȯ",
    "e870": "ṗ",
    "e872": "ṙ",
    "e873": "ṡ",
    "e874": "ṫ",
    "e877": "ẇ",
    "e878": "ẋ",
    "e879": "ẏ",
    "e920": "¯",
    "e941": "Ā",
    "e945": "Ē",
    "e947": "Ḡ",
    "e949": "Ī",
    "e94f": "Ō",
    "e955": "Ū",
    "e959": "Ȳ",
    "e95c": "Ǣ",
    "e961": "ā",
    "e965": "ē",
    "e967": "ḡ",
    "e969": "ī",
    "e96f": "ō",
    "e975": "ū",
    "e979": "ȳ",
    "e97c": "ǣ",
    "ea20": "ˇ",
    "ea41": "Ă",
    "ea45": "Ě",
    "ea49": "Ǐ",
    "ea4f": "Ǒ",
    "ea61": "ă",
    "ea65": "ě",
    "ea69": "ǐ",
    "ea6f": "ǒ",
    "eb20": "˛",
    "eb49": "Į",
    "eb4f": "Ǫ",
    "eb55": "Ų",
    "eb69": "į",
    "eb6f": "ǫ",
    "eb75": "ų",
    "ec20": "˝",
    "ec4f": "Ő",
    "ec55": "Ű",
    "ec6f": "ő",
    "ec75": "ű",
    "23": "£",
    "7c": "æ",
    "7d": "ø",
    "7e": "§",
    "80": "#",
    "5c": "Æ",
    "5d": "Ø",
    "5e": "÷",
    "2d": "-",
    "5f": "–",
    "81": "ß",
    "82": "²",
    "9c": "Ł",
    "bc": "ł",
    "87": "þ",
    "89": "ð",
    "88": "Þ",
    "8c": "Đ",
    "7b": "ı",
    "ae": "đ",
    "a8": "¿",
    "ad": "¡",
    "a6": "ª",
    "a7": "º",
    "ab": "½",
    "bb": "»",
    "b3": "³",
    "1c": "“",
    "1d": "”",
    "18": "‘",
    "19": "’",
    "13": "–",
    "14": "—",
    "83": "³",
    "5b": "¤",
    "85": "ŧ",
    "86": "Ŧ",
    "8a": "«",
    "8b": "»",
    "8e": "Ŋ",
    "8d": "ŋ",
    "95": "Ħ",
    "96": "ħ",
    "9a": "Œ",
    "9b": "¢",
    "9d": "¥",
    "9e": "€",
    "a9": "°",
    "aa": "¾",
    "ac": "¼",
    "b1": "±",
    "b5": "µ",
    "ba": "œ",
    "bf": "ǧ",
    "d2": "®",
    "d4": "©",
    "c0": "[",
    "c1": "]"
  },
  specialTurkishChars: {
    "e720": "˘",
    "e741": "Ă",
    "e745": "Ĕ",
    "e747": "Ğ",
    "e749": "Ĭ",
    "e74f": "Ŏ",
    "e755": "Ŭ",
    "e761": "ă",
    "e765": "ĕ",
    "e769": "ĭ",
    "e76f": "ŏ",
    "e775": "ŭ",
    "ea20": "˘",
    "ea45": "Ĕ",
    "ea47": "Ğ",
    "ea49": "Ĭ",
    "ea4f": "Ŏ",
    "ea55": "Ŭ",
    "ea65": "ĕ",
    "ea67": "ğ",
    "ea69": "ĭ",
    "ea6f": "ŏ",
    "ea75": "ŭ"
  },
  specialHebrewChars: {
    "80": "ְ",
    "81": "ֱ",
    "82": "ֲ",
    "83": "ֳ",
    "84": "ִ",
    "85": "ֵ",
    "86": "ֶ",
    "87": "ַ",
    "88": "ָ",
    "89": "ֹ",
    "8b": "ֻ",
    "8c": "ּ",
    "8d": "ֽ",
    "92": "֗",
    "a0": "א",
    "a1": "ב",
    "a2": "ג",
    "a3": "ד",
    "a4": "ה",
    "a5": "ו",
    "a6": "ז",
    "a7": "ח",
    "a8": "ט",
    "a9": "י",
    "aa": "ך",
    "ab": "כ",
    "ac": "ל",
    "ad": "ם",
    "ae": "מ",
    "af": "ן",
    "b0": "נ",
    "b1": "ס",
    "b2": "ע",
    "b3": "ף",
    "b4": "פ",
    "b5": "ץ",
    "b6": "צ",
    "b7": "ק",
    "b8": "ר",
    "b9": "ש",
    "ba": "ת",
    "bb": "װ",
    "bc": "ױ",
    "bd": "ײ",
    "cc": "ףּ",
    "cd": "רּ",
    "ce": "אַ",
    "cf": "אּ",
    "d0": "אָ",
    "d1": "שּׂ",
    "d2": "שּׁ",
    "d3": "שׂ",
    "d4": "שׁ",
    "d5": "ﬥ",
    "d6": "ﬠ",
    "d7": "לּ",
    "d8": "יּ",
    "d9": "טּ",
    "da": "זּ",
    "db": "וּ",
    "dc": "הּ",
    "dd": "דּ",
    "de": "גּ",
    "df": "בּ",
    "2e": ".",
    "2c": ","
  },
  specialCyrillicChars: {
    "20": " ",
    "21": "!",
    "22": "Э",
    "23": "/",
    "24": "?",
    "25": ":",
    "26": ".",
    "27": "э",
    "28": "(",
    "29": ")",
    "2a": ";",
    "2b": "+",
    "2c": "б",
    "2d": "-",
    "2e": "ю",
    "3a": "Ж",
    "3b": "ж",
    "3d": "=",
    "41": "Ф",
    "42": "И",
    "43": "С",
    "44": "В",
    "45": "У",
    "46": "А",
    "47": "П",
    "48": "Р",
    "49": "Ш",
    "4a": "О",
    "4b": "Л",
    "4c": "Д",
    "4d": "Ь",
    "4e": "Т",
    "4f": "Щ",
    "50": "З",
    "51": "Q",
    "52": "К",
    "53": "Ы",
    "54": "Е",
    "55": "Г",
    "56": "М",
    "57": "Ц",
    "58": "Ч",
    "59": "Н",
    "5a": "Я",
    "5b": "х",
    "5d": "ъ",
    "5e": ",",
    "5f": "-",
    "61": "ф",
    "62": "и",
    "63": "с",
    "64": "в",
    "65": "у",
    "66": "а",
    "67": "п",
    "68": "р",
    "69": "ш",
    "6a": "о",
    "6b": "л",
    "6c": "д",
    "6d": "ь",
    "6e": "т",
    "6f": "щ",
    "70": "з",
    "72": "к",
    "73": "ы",
    "74": "е",
    "75": "г",
    "76": "м",
    "77": "ц",
    "78": "ч",
    "79": "н",
    "7a": "я",
    "7b": "Х",
    "7d": "Ъ",
    "80": "Б",
    "81": "Ю",
    "82": "Ђ",
    "84": "Є",
    "85": "Ѕ",
    "86": "І",
    "88": "Ј",
    "89": "Љ",
    "8a": "Њ",
    "8b": "Ћ",
    "8c": "Ґ",
    "8d": "ґ",
    "8f": "Џ",
    "90": "№",
    "92": "ђ",
    "94": "є",
    "95": "ѕ",
    "96": "і",
    "98": "ј",
    "99": "љ",
    "9a": "њ",
    "9b": "ћ",
    "9d": "§",
    "9f": "џ",
    "a2": "%",
    "a4": "&",
    "ac": "C",
    "ad": "D",
    "ae": "E",
    "af": "F",
    "b0": "G",
    "b1": "H",
    "b2": "'",
    "b3": '"',
    "b4": "I",
    "b5": "J",
    "b6": "K",
    "b7": "L",
    "b8": "M",
    "b9": "N",
    "ba": "P",
    "bb": "Q",
    "bc": "R",
    "bd": "S",
    "be": "T",
    "bf": "U",
    "c0": "V",
    "c1": "*",
    "c2": "W",
    "c3": "X",
    "c4": "Y",
    "c5": "Z",
    "c6": "b",
    "c7": "c",
    "c8": "d",
    "c9": "e",
    "ca": "f",
    "cb": "g",
    "cc": "h",
    "cd": "i",
    "ce": "j",
    "cf": "k",
    "d0": "—",
    "d1": "l",
    "d2": "m",
    "d3": "n",
    "d4": "o",
    "d5": "p",
    "d6": "q",
    "d7": "r",
    "d8": "s",
    "d9": "t",
    "da": "u",
    "db": "v",
    "dc": "w",
    "dd": "э",
    "de": "ю",
    "df": "z",
    "e3": "`",
    "e5": "¨",
    "e020": "˘",
    "e03a": "Ӂ",
    "e03b": "ӂ",
    "e042": "Й",
    "e045": "Ў",
    "e046": "Ӑ",
    "e054": "Ӗ",
    "e062": "й",
    "e065": "ў",
    "e066": "ӑ",
    "e074": "ӗ",
    "e220": "´",
    "e252": "Ќ",
    "e255": "Ѓ",
    "e272": "ќ",
    "e275": "ѓ",
    "e342": "Ѝ",
    "e354": "Ѐ",
    "e362": "ѝ",
    "e374": "ѐ",
    "e522": "Ӭ",
    "e527": "ӭ",
    "e53a": "Ӝ",
    "e53b": "ӝ",
    "e542": "Ӥ",
    "e545": "Ӱ",
    "e546": "Ӓ",
    "e54a": "Ӧ",
    "e550": "Ӟ",
    "e553": "Ӹ",
    "e554": "Ё",
    "e558": "Ӵ",
    "e562": "ӥ",
    "e565": "ӱ",
    "e566": "ӓ",
    "e56a": "ӧ",
    "e570": "ӟ",
    "e573": "ӹ",
    "e574": "ё",
    "e578": "ӵ",
    "e586": "Ї",
    "e596": "ї",
    "e5b4": "Ї"
  },
  specialGreekChars: {
    "20": " ",
    "21": "!",
    "22": '"',
    "23": "£",
    "24": "$",
    "25": "%",
    "26": "&",
    "27": "'",
    "28": "(",
    "29": ")",
    "2a": "*",
    "2b": "+",
    "2c": ",",
    "2d": "-",
    "2e": ".",
    "2f": "/",
    "3a": ":",
    "3b": ";",
    "3d": "=",
    "3f": "?",
    "40": "@",
    "41": "Α",
    "42": "Β",
    "43": "Γ",
    "44": "Δ",
    "45": "Ε",
    "46": "Ζ",
    "47": "Η",
    "48": "Θ",
    "49": "Ι",
    "4a": "Κ",
    "4b": "Λ",
    "4c": "Μ",
    "4d": "Ν",
    "4e": "Ξ",
    "4f": "Ο",
    "50": "Π",
    "51": "Ρ",
    "52": "R",
    "53": "Σ",
    "54": "Τ",
    "55": "Υ",
    "56": "Φ",
    "57": "Χ",
    "58": "Ψ",
    "59": "Ω",
    "5a": "Z",
    "5f": "-",
    "61": "α",
    "62": "β",
    "63": "γ",
    "64": "δ",
    "65": "ε",
    "66": "ζ",
    "67": "η",
    "68": "θ",
    "69": "ι",
    "6a": "κ",
    "6b": "λ",
    "6c": "μ",
    "6d": "ν",
    "6e": "ξ",
    "6f": "ο",
    "70": "π",
    "71": "ρ",
    "72": "ς",
    "73": "σ",
    "74": "τ",
    "75": "υ",
    "76": "φ",
    "77": "χ",
    "78": "ψ",
    "79": "ω",
    "7a": "z",
    "7e": "§",
    "80": "#",
    "81": "ß",
    "82": "²",
    "83": "³",
    "84": "«",
    "85": "»",
    "86": "±",
    "87": "þ",
    "88": "Þ",
    "89": "ð",
    "8c": "A",
    "8d": "B",
    "8e": "C",
    "8f": "D",
    "90": "E",
    "91": "F",
    "92": "G",
    "93": "H",
    "94": "I",
    "95": "J",
    "96": "K",
    "97": "L",
    "98": "M",
    "99": "N",
    "9a": "O",
    "9b": "P",
    "9c": "Q",
    "9d": "R",
    "9e": "S",
    "9f": "T",
    "a0": "U",
    "a1": "V",
    "a2": "W",
    "a3": "X",
    "a4": "Y",
    "a5": "Z",
    "a9": "°",
    "ab": "½",
    "ac": "a",
    "ad": "b",
    "ae": "c",
    "af": "d",
    "b0": "e",
    "b1": "f",
    "b2": "g",
    "b3": "h",
    "b4": "i",
    "b5": "j",
    "b6": "k",
    "b7": "l",
    "b8": "m",
    "b9": "n",
    "ba": "o",
    "bb": "p",
    "bc": "q",
    "bd": "r",
    "be": "s",
    "bf": "t",
    "c0": "u",
    "c1": "v",
    "c2": "w",
    "c3": "x",
    "c4": "y",
    "c5": "z",
    "202a": "®",
    "e241": "Ά",
    "e242": "Β́",
    "e243": "Γ́",
    "e244": "Δ́",
    "e245": "Έ",
    "e246": "Ζ́",
    "e247": "Ή",
    "e248": "Θ́",
    "e249": "Ί",
    "e24a": "Κ́",
    "e24b": "Λ́",
    "e24c": "Μ́",
    "e24d": "Ν́",
    "e24e": "Ξ́",
    "e24f": "Ό",
    "e255": "Ύ",
    "e258": "Ψ́",
    "e259": "Ώ",
    "e261": "ά",
    "e262": "β́",
    "e263": "γ́",
    "e264": "δ́",
    "e265": "έ",
    "e266": "ζ",
    "e267": "ή",
    "e268": "θ́",
    "e269": "ί",
    "e26a": "κ́",
    "e26b": "λ́",
    "e26c": "μ́",
    "e26d": "ν́",
    "e26e": "ξ",
    "e26f": "ό",
    "e270": "π",
    "e271": "ρ́",
    "e272": "ς́",
    "e273": "σ́",
    "e274": "τ́",
    "e275": "ύ",
    "e276": "φ́",
    "e277": "χ́",
    "e278": "ψ́",
    "e279": "ώ",
    "e27b": "ί",
    "e320": "`",
    "e399": "Ǹ",
    "e39a": "Ò",
    "e3a0": "Ù",
    "e3a2": "Ẁ",
    "e3a4": "Ỳ",
    "e3b9": "ǹ",
    "e3c2": "ẁ",
    "e3c4": "ỳ",
    "e549": "Ϊ",
    "e555": "Ϋ",
    "e561": "α̈",
    "e562": "β̈",
    "e563": "γ̈",
    "e564": "δ̈",
    "e565": "ε̈",
    "e566": "ζ̈",
    "e567": "η̈",
    "e568": "θ̈",
    "e569": "ϊ",
    "e56a": "κ̈",
    "e56b": "λ̈",
    "e56c": "μ̈",
    "e56d": "ν̈",
    "e56e": "ξ̈",
    "e56f": "ο̈",
    "e570": "π̈",
    "e571": "ρ",
    "e572": "ς̈",
    "e573": "σ̈",
    "e574": "τ̈",
    "e575": "ϋ",
    "e576": "φ̈",
    "e577": "χ̈",
    "e578": "ψ̈",
    "e579": "ω̈",
    "e57b": "ϊ",
    "e5e269": "ΐ",
    "e5e275": "ΰ"
  },
  specialThaiChars: {
    "20": " ",
    "21": "!",
    "22": "\"",
    "23": "#",
    "24": "$",
    "25": "%",
    "26": "&",
    "27": "'",
    "28": "(",
    "29": ")",
    "2a": "*",
    "2b": "+",
    "2c": ",",
    "2d": "-",
    "2e": ".",
    "2f": "/",
    "30": "0",
    "31": "1",
    "32": "2",
    "33": "3",
    "34": "4",
    "35": "5",
    "36": "6",
    "37": "7",
    "38": "8",
    "39": "9",
    "3a": ":",
    "3b": ";",
    "3c": "<",
    "3d": "<",
    "3e": ">",
    "3f": "?",
    "40": "@",
    "41": "a",
    "42": "b",
    "43": "c",
    "44": "d",
    "45": "e",
    "46": "f",
    "47": "g",
    "48": "h",
    "49": "i",
    "4a": "j",
    "4b": "k",
    "4c": "l",
    "4d": "m",
    "4e": "n",
    "4f": "o",
    "50": "p",
    "51": "q",
    "52": "r",
    "53": "s",
    "54": "t",
    "55": "u",
    "56": "v",
    "57": "w",
    "58": "x",
    "59": "y",
    "5a": "z",
    "5b": "[",
    "5c": "\\",
    "5d": "]",
    "5e": "^",
    "5f": "_",
    "60": "`",
    "61": "a",
    "62": "b",
    "63": "c",
    "64": "d",
    "65": "e",
    "66": "f",
    "67": "g",
    "68": "h",
    "69": "i",
    "6a": "j",
    "6b": "k",
    "6c": "l",
    "6d": "m",
    "6e": "n",
    "6f": "o",
    "70": "p",
    "71": "q",
    "72": "r",
    "73": "s",
    "74": "t",
    "75": "u",
    "76": "v",
    "77": "w",
    "78": "z",
    "79": "y",
    "7a": "z",
    "80": "เ",
    // 80
    "81": "แ",
    // 81
    "82": "โ",
    // 82
    "83": "ใ",
    // 83
    "84": "ไ",
    // 84
    "85": "ๅ",
    // 85
    "86": "ๆ",
    // 86
    "87": "็",
    // 87
    "88": "่",
    // 88
    "89": "้",
    // 89
    "8a": "๊",
    // 8a
    "8b": "๋",
    // 8b
    "8c": "์",
    // 8c
    "8d": "ํ",
    // 8d
    "8e": "๎",
    // 8e
    "8f": "๏",
    // 8f
    "90": "๐",
    // 90
    "91": "๑",
    // 91
    "92": "๒",
    // 92
    "93": "๓",
    // 93
    "94": "๔",
    // 94
    "95": "๕",
    // 95
    "96": "๖",
    // 96
    "97": "๗",
    // 97
    "98": "๘",
    // 98
    "99": "๙",
    // 99
    "9a": "๚",
    // 9a
    "9b": "๛",
    // 9b
    "a0": " ",
    // a0
    "a1": "ก",
    // a1
    "a2": "ข",
    // a2
    "a3": "ฃ",
    // a3
    "a4": "ค",
    // a4
    "a5": "ฅ",
    // a5
    "a6": "ฆ",
    // a6
    "a7": "ง",
    // a7
    "a8": "จ",
    // a8
    "a9": "ฉ",
    // a9
    "aa": "ช",
    // aa
    "ab": "ซ",
    // ab
    "ac": "ฌ",
    // ac
    "ad": "ญ",
    // ad
    "ae": "ฎ",
    // ae
    "af": "ฏ",
    // af
    "b0": "ฐ",
    // b0
    "b1": "ฑ",
    // b1
    "b2": "ฒ",
    // b2
    "b3": "ณ",
    // b3
    "b4": "ด",
    // b4
    "b5": "ต",
    // b5
    "b6": "ถ",
    // b6
    "b7": "ท",
    // b7
    "b8": "ธ",
    // b8
    "b9": "น",
    // b9
    "ba": "บ",
    // ba
    "bb": "ป",
    // bb
    "bc": "ผ",
    // bc
    "bd": "ฝ",
    // bd
    "be": "พ",
    // be
    "bf": "ฟ",
    // bf
    "c0": "ภ",
    // c0
    "c1": "ม",
    // c1
    "c2": "ย",
    // c2
    "c3": "ร",
    // c3
    "c4": "ฤ",
    // c4
    "c5": "ล",
    // c5
    "c6": "ฦ",
    // c6
    "c7": "ว",
    // c7
    "c8": "ศ",
    // c8
    "c9": "ษ",
    // c9
    "ca": "ส",
    // ca
    "cb": "ห",
    // cb
    "cc": "ฬ",
    // cc
    "cd": "อ",
    // cd
    "ce": "ฮ",
    // ce
    "cf": "ฯ",
    // cf
    "d0": "ะ",
    // d0
    "d1": "ั",
    // d1
    "d2": "า",
    // d2
    "d3": "ำ",
    // d3
    "d4": "ิ",
    // d4
    "d5": "ี",
    // d5
    "d6": "ึ",
    // d6
    "d7": "ื",
    // d7
    "d8": "ุ",
    // d8
    "d9": "ู",
    // d9
    "da": "ฺ",
    // da
    "db": "฿",
    // db
    "e3": "ใ"
  },
  // Language to code page mapping
  languageToCodePage: {
    'ARA': 28596,
    // Arabic
    'CHI': 950,
    // Traditional Chinese
    'ZHO': 936,
    // Simplified Chinese
    'HRV': 28592,
    // Croatian
    'CZE': 28592,
    // Czech
    'DAN': 28591,
    // Danish
    'NLD': 28591,
    // Dutch
    'ENG': 28591,
    // English
    'EST': 28592,
    // Estonian
    'FIN': 28591,
    // Finnish
    'FRA': 28591,
    // French
    'DEU': 28591,
    // German
    'GRE': 28597,
    // Greek
    'HEB': 28598,
    // Hebrew
    'HUN': 28592,
    // Hungarian
    'ITA': 28591,
    // Italian
    'JPN': 932,
    // Japanese
    'KOR': 949,
    // Korean
    'LAV': 28592,
    // Latvian
    'LIT': 28592,
    // Lithuanian
    'NOR': 28591,
    // Norwegian
    'POL': 28592,
    // Polish
    'POR': 28591,
    // Portuguese
    'RON': 28592,
    // Romanian
    'RUS': 28595,
    // Russian
    'SRP': 28592,
    // Serbian
    'SLK': 28592,
    // Slovak
    'SLV': 28592,
    // Slovenian
    'SPA': 28591,
    // Spanish
    'SWE': 28591,
    // Swedish
    'THA': 874,
    // Thai
    'TUR': 28599,
    // Turkish
    'UKR': 28595,
    // Ukrainian
    'VIE': 1258 // Vietnamese
  },
  /**
   * Analyzes a PAC subtitle file to detect language and code page
   * @param {string|Array} buffer - Hex string or array of bytes
   * @returns {Object} Object containing language and code page information
   */
  analyzePacFile: function (buffer) {
    // Initialize result object
    let result = {
      language: null,
      codePage: 28591,
      // Default ISO 8859-1 Latin
      hasStory: false,
      secondaryCodePageIsMain: false
    };

    // Convert buffer to array of byte values if it's a hex string
    let bytes = [];
    if (typeof buffer === 'string') {
      // If the buffer is a hex string, convert to byte array
      bytes = buffer.match(/(..?)/g).map(hex => parseInt(hex, 16));
    } else if (Array.isArray(buffer)) {
      // If it's already an array
      bytes = buffer.map(hex => typeof hex === 'string' ? parseInt(hex, 16) : hex);
    }
    if (bytes.length < 15) return result;
    let total = 0;
    let secondaryUse = 0;
    let firstIsSecondary = false;

    // Start analyzing from byte 15 as in the C# example
    for (let i = 15; i < bytes.length - 1; i++) {
      // Check for FE byte and specific pattern before it (0x60/0x61)
      if (bytes[i] === 0xFE && (bytes[i - 15] === 0x60 || bytes[i - 15] === 0x61 || bytes[i - 12] === 0x60 || bytes[i - 12] === 0x61)) {
        // Skip ahead if there are multiple FE bytes in sequence
        while (i + 3 < bytes.length && bytes[i + 3] === 0xFE) {
          i += 3;
        }

        // Check if secondary codepage is being used
        let secondary = (bytes[i + 1] & 0x08) !== 0;
        if (total === 0) {
          firstIsSecondary = secondary;

          // Look for language or story markers
          for (let j = i + 2; j < bytes.length - 6 && (bytes[j] !== 0x00 || bytes[j - 1] === 0xFE || bytes[j - 2] === 0xFE); j++) {
            if (bytes[j] === 0xFE) {
              secondary = (bytes[j + 1] & 0x08) !== 0;
            }

            // Find the end of the line
            let lineEnd = j;
            while (lineEnd < bytes.length && bytes[lineEnd] !== 0xFE && bytes[lineEnd] !== 0x00) {
              lineEnd++;
            }

            // Convert to ASCII to check for specific markers
            let possibleText = "";
            for (let k = j; k < Math.min(j + 20, bytes.length); k++) {
              if (bytes[k] >= 32 && bytes[k] <= 126) {
                // ASCII printable range
                possibleText += String.fromCharCode(bytes[k]);
              }
            }

            // Check for "STORY:" marker
            if (possibleText.toUpperCase().startsWith("STORY:")) {
              j += 6;
              firstIsSecondary = secondary;
              result.hasStory = true;
            }
            // Check for "LANG:" marker
            else if (possibleText.toUpperCase().startsWith("LANG:") && lineEnd > j + 5) {
              // Extract language code
              let langText = "";
              for (let k = j + 5; k < lineEnd && k < bytes.length; k++) {
                if (bytes[k] >= 32 && bytes[k] <= 126) {
                  // ASCII printable range
                  langText += String.fromCharCode(bytes[k]);
                }
              }
              result.language = langText.trim().toUpperCase();
            }
          }
        }
        total++;
        if (secondary) {
          secondaryUse++;
        }
      }
    }

    // Determine if secondary code page should be the main one
    result.secondaryCodePageIsMain = secondaryUse > (result.hasStory && firstIsSecondary ? total - 1 : 0);

    // Map the language to a code page if detected
    if (result.language && this.languageToCodePage[result.language]) {
      result.codePage = this.languageToCodePage[result.language];
    } else if (result.secondaryCodePageIsMain) {
      // If secondary code page is main but we don't know the language,
      // we could make an educated guess based on character frequency analysis
      // For now, we'll stick with the default code page
    }
    return result;
  }
};